import GeneratePostsComponent from "components/Socials/GeneratePosts"
import Typography from "components/Typography"

import { ComponentProps } from "."
import { Wrapper } from "./styled"

const GeneratePosts = (props: ComponentProps) => (
  <Wrapper>
    <Typography.H1>{"Generate Posts"}</Typography.H1>

    <GeneratePostsComponent {...props} />
  </Wrapper>
)

export default GeneratePosts
